"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wyvern_js_1 = require("wyvern-js");
exports.DEFAULT_GAS_INCREASE_FACTOR = 1.01;
exports.NULL_ADDRESS = wyvern_js_1.WyvernProtocol.NULL_ADDRESS;
exports.NULL_BLOCK_HASH = '0x0000000000000000000000000000000000000000000000000000000000000000';
exports.OPENSEA_FEE_RECIPIENT = '0x5b3256965e7c3cf26e11fcaf296dfc8807c01073';
exports.DEP_INFURA_KEY = 'e8695bce67944848aa95459fac052f8e';
exports.MAINNET_PROVIDER_URL = 'https://api.opensea.io/jsonrpc/v1/';
exports.RINKEBY_PROVIDER_URL = 'https://rinkeby-api.opensea.io/jsonrpc/v1/';
exports.INVERSE_BASIS_POINT = 10000;
exports.MAX_UINT_256 = wyvern_js_1.WyvernProtocol.MAX_UINT_256;
exports.WYVERN_EXCHANGE_ADDRESS_MAINNET = '0x7be8076f4ea4a4ad08075c2508e481d6c946d12b';
exports.WYVERN_EXCHANGE_ADDRESS_RINKEBY = '0x5206e78b21ce315ce284fb24cf05e0585a93b1d9';
exports.ENJIN_COIN_ADDRESS = '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c';
exports.MANA_ADDRESS = '0x0f5d2fb29fb7d3cfee444a200298f468908cc942';
exports.ENJIN_ADDRESS = '0xfaaFDc07907ff5120a76b34b731b278c38d6043C';
exports.ENJIN_LEGACY_ADDRESS = '0x8562c38485B1E8cCd82E44F89823dA76C98eb0Ab';
exports.CK_ADDRESS = '0x06012c8cf97bead5deae237070f9587f8e7a266d';
exports.CK_RINKEBY_ADDRESS = '0x16baf0de678e52367adc69fd067e5edd1d33e3bf';
exports.WRAPPED_NFT_FACTORY_ADDRESS_MAINNET = '0xf11b5815b143472b7f7c52af0bfa6c6a2c8f40e1';
exports.WRAPPED_NFT_FACTORY_ADDRESS_RINKEBY = '0x94c71c87244b862cfd64d36af468309e4804ec09';
exports.WRAPPED_NFT_LIQUIDATION_PROXY_ADDRESS_MAINNET = '0x995835145dd85c012f3e2d7d5561abd626658c04';
exports.WRAPPED_NFT_LIQUIDATION_PROXY_ADDRESS_RINKEBY = '0xaa775Eb452353aB17f7cf182915667c2598D43d3';
exports.UNISWAP_FACTORY_ADDRESS_MAINNET = '0xc0a47dFe034B400B47bDaD5FecDa2621de6c4d95';
exports.UNISWAP_FACTORY_ADDRESS_RINKEBY = '0xf5D915570BC477f9B8D6C0E980aA81757A3AaC36';
exports.DEFAULT_WRAPPED_NFT_LIQUIDATION_UNISWAP_SLIPPAGE_IN_BASIS_POINTS = 1000;
exports.CHEEZE_WIZARDS_GUILD_ADDRESS = wyvern_js_1.WyvernProtocol.NULL_ADDRESS; // TODO: Update this address once Dapper has deployed their mainnet contracts
exports.CHEEZE_WIZARDS_GUILD_RINKEBY_ADDRESS = '0x095731b672b76b00A0b5cb9D8258CD3F6E976cB2';
exports.CHEEZE_WIZARDS_BASIC_TOURNAMENT_ADDRESS = wyvern_js_1.WyvernProtocol.NULL_ADDRESS; // TODO: Update this address once Dapper has deployed their mainnet contracts
exports.CHEEZE_WIZARDS_BASIC_TOURNAMENT_RINKEBY_ADDRESS = '0x8852f5F7d1BB867AAf8fdBB0851Aa431d1df5ca1';
exports.DECENTRALAND_ESTATE_ADDRESS = '0x959e104e1a4db6317fa58f8295f586e1a978c297';
exports.STATIC_CALL_TX_ORIGIN_ADDRESS = '0xbff6ade67e3717101dd8d0a7f3de1bf6623a2ba8';
exports.STATIC_CALL_TX_ORIGIN_RINKEBY_ADDRESS = '0xe291abab95677bc652a44f973a8e06d48464e11c';
exports.STATIC_CALL_CHEEZE_WIZARDS_ADDRESS = wyvern_js_1.WyvernProtocol.NULL_ADDRESS; // TODO: Deploy this address once Dapper has deployed their mainnet contracts
exports.STATIC_CALL_CHEEZE_WIZARDS_RINKEBY_ADDRESS = '0x8a640bdf8886dd6ca1fad9f22382b50deeacde08';
exports.STATIC_CALL_DECENTRALAND_ESTATES_ADDRESS = '0x93c3cd7ba04556d2e3d7b8106ce0f83e24a87a7e';
exports.DEFAULT_BUYER_FEE_BASIS_POINTS = 0;
exports.DEFAULT_SELLER_FEE_BASIS_POINTS = 250;
exports.OPENSEA_SELLER_BOUNTY_BASIS_POINTS = 100;
exports.DEFAULT_MAX_BOUNTY = exports.DEFAULT_SELLER_FEE_BASIS_POINTS;
exports.MIN_EXPIRATION_SECONDS = 10;
exports.ORDER_MATCHING_LATENCY_SECONDS = 60 * 60 * 24 * 7;
exports.SELL_ORDER_BATCH_SIZE = 3;
exports.ORDERBOOK_VERSION = 1;
exports.API_VERSION = 1;
exports.API_BASE_MAINNET = 'https://api.opensea.io';
exports.API_BASE_RINKEBY = 'https://rinkeby-api.opensea.io';
exports.SITE_HOST_MAINNET = 'https://opensea.io';
exports.SITE_HOST_RINKEBY = 'https://rinkeby.opensea.io';
exports.ORDERBOOK_PATH = "/wyvern/v" + exports.ORDERBOOK_VERSION;
exports.API_PATH = "/api/v" + exports.ORDERBOOK_VERSION;
//# sourceMappingURL=constants.js.map